<template>
  <div ref="node" class="flex flex-col items-center px-4 py-2 bg-white rounded shadow mb-4 border">
    <!-- 節點資料展示 -->
    <div v-if="Array.isArray(node)" class="flex flex-wrap space-x-4 mb-2">
      <div
        v-for="(item, idx) in node"
        :key="idx"
        class="relative flex flex-col items-center border px-2 pt-6 pb-2 rounded-lg shadow-sm bg-gray-50"
      >
        <!-- 刪除資料按鈕 (右上角) -->
        <button
          v-if="!(node.length === 1 && groupIndex === 0) && editPage === false"
          @click="deleteNodeData(idx)"
          class="absolute top-1 right-1 text-red-500 hover:text-red-600 focus:outline-none"
          v-tooltip.top="'刪除本行銷活動'"
        >
          <i class="pi pi-times"></i>
        </button>

        <!-- PrimeVue 的 Dropdown -->
        <Dropdown 
          v-model="item.method"
          :options="item.method === 'META_TEST' ? optionsTest : options1"
          :disabled="item.method === 'META_TEST' || editPage === true" 
          optionLabel="label" 
          optionValue="value" 
          class="w-40 mt-1" 
          placeholder="Select Method"
          @change="methodChange(index, idx, item.method)"
        />
        <Dropdown 
          v-model="item.platform" 
          :options="options2"
          :disabled="item.method === 'META_TEST' || editPage === true" 
          optionLabel="label" 
          optionValue="value" 
          class="w-40 mt-2" 
          placeholder="Select Platform"
        />

        <!-- InputSwitch 替代 Radio -->
        <div class="flex items-center mt-2 space-x-2">
          <InputSwitch
            v-model="item.isGoAhead"
            @change="updateIsGoAhead(idx)"
            class="text-blue-600"
            :disabled="(!isTestStage && isLastStage) || editPage === true" 
          />
          <label class="text-sm font-medium text-gray-700">設為前進條件</label>
        </div>

        <div v-show="item.isGoAhead === true" class="flex items-center mt-2 space-x-2">
          <InputSwitch
            v-model="item.isHold"
            class="text-blue-600"
            :disabled="(!isTestStage && isLastStage) || editPage === true" 
          />
          <label class="text-sm font-medium text-gray-700">
            設為保留
            <i
              class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
              v-tooltip.top="'若設為保留，則執行到本階段後，將暫停前進。'"
            ></i>
          </label>
        </div>
      </div>
    </div>

    <!-- 操作按鈕 -->
    <div v-if="!editPage" class="flex space-x-4 border-t border-dashed pt-2">
      <button
        v-if="!isTestStage && isLastStage"
        @click="addNextStage"
        class="flex items-center bg-blue-500 text-white px-4 py-2 rounded-lg shadow hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300"
      >
        <i class="pi pi-plus mr-2"></i>新增階段
      </button>
      <button
        v-if="!isTestStage"
        @click="addCurrentNodeData"
        class="flex items-center bg-green-500 text-white px-4 py-2 rounded-lg shadow hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-300"
      >
        <i class="pi pi-plus mr-2"></i>新增行銷活動
      </button>
      <button
        v-if="!isTestStage && !isSingleNode && totalNodes > 2"
        @click="deleteCurrentNode"
        class="flex items-center bg-red-500 text-white px-4 py-2 rounded-lg shadow hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-300"
      >
        <i class="pi pi-trash mr-2"></i>刪除本階段
      </button>
    </div>
  </div>
</template>

<script>
import Dropdown from "primevue/dropdown";
import InputSwitch from "primevue/inputswitch";

export default {
  components: {
    Dropdown,
    InputSwitch,
  },
  props: {
    node: {
      type: [Number, Array],
      required: true,
    },
    groupIndex: {
      type: Number,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    isSingleNode: {
      type: Boolean,
      required: true,
    },
    totalNodes: {
      type: Number,
      required: true,
    },
    isLastStage: {
      type: Boolean
    },
    isTestStage: {
      type: Boolean,
    },
    editPage: {
      type: Boolean
    },
  },
  data() {
    return {
      optionsTest: [
        { label: "測試素材", value: "META_TEST" },
      ],
      options1: [
        { label: "精準興趣", value: "META_KW" },
        { label: "類似受眾", value: "META_LA" },
        { label: "再行銷", value: "META_RT" },
        { label: "ASC", value: "META_ASC" },
      ],
      options2: [
        { label: "Facebook", value: "facebook" },
      ],
      isHold: false,
    };
  },
  watch: {
    'index': function(value){
      console.log('StageTreeNode index', value);
    },
    'isLastStage': function(value){
      console.log('StageTreeNode isLastStage', value);
    }
  },
  methods: {
    addNextStage() {
      this.$emit("add-next-stage", this.groupIndex, this.index);
    },
    addCurrentNodeData() {
      this.$emit("add-current-node-data", this.groupIndex, this.index);
    },
    deleteCurrentNode() {
      this.$emit("delete-node", this.groupIndex, this.index);
    },
    deleteNodeData(subIndex) {
      this.$emit("delete-node", this.groupIndex, this.index, subIndex);
    },
    updateIsGoAhead(subIndex) {
      this.$emit("update-is-go-ahead", this.groupIndex, this.index, subIndex);
    },
    updateIsHold(subIndex) {
      this.$emit("update-is-hold", this.groupIndex, this.index, subIndex);
    },
    methodChange(node_index, campaign_index, item_method){
      console.log('methodChange',node_index, campaign_index, item_method);
      this.$emit("update-method-change", node_index, campaign_index, item_method);
    }
  },
};
</script>

<style>
/* 自定義樣式可在這裡加入 */
</style>
